import { useCallback } from "react";
import client from "../helpers/network/client";
import { User, UserDto } from "../models/authentication/user";
import { deleteCookie, setCookie } from "../helpers/utils/storage.util";

const login = (email: string) =>
  client
    .post<string>(`api/key/${encodeURIComponent(email)}`, { raw: true })
    .then((r) => r.data)
    .then((token) => setCookie("jwt-token", token));

const logout = () => {
  deleteCookie("jwt-token");
};

const getProfile = () => {
  return client.get<UserDto>("profile").then((r) => r.data);
};

const registerTeacher = (createTeacher: {
  email: string;
  password: string;
  name: string;
  lastname: string;
}) => {
  throw Error("Not implemented");
};

/**
 * Hook that provides user api calls.
 * Calls the user api and maps the responses to frontend compatible objects.
 * Never directly use api functions, always use the wrapper hook!
 */
export const useUserApi = () => {
  const _getProfile = useCallback(
    () => getProfile().then((dto) => User.fromUserDto(dto)),
    [],
  );

  return {
    login,
    logout,
    register: registerTeacher,
    getProfile: _getProfile,
  };
};

/**
 * Use this only for configuration of http clients that cannot be done inside a hook
 */
export const userApi = {
  logout,
};
